/* eslint-disable header/header */
export const name = "@azure/msal-common";
export const version = "15.12.0";
